import { defaultInitialState } from '../utils';
import { SET_PASSCODE_PARAMS, SET_PASSCODE_DONE, SET_PASSCODE_ERROR, SET_PASSCODE_RESET, REMOVE_PASSCODE_PARAMS, REMOVE_PASSCODE_DONE, REMOVE_PASSCODE_ERROR, REMOVE_PASSCODE_RESET } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { isRemoved: false, isAutoApplied: false });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PASSCODE_PARAMS:
        case REMOVE_PASSCODE_PARAMS:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case SET_PASSCODE_DONE: {
            return Object.assign(Object.assign({}, state), { isUpdated: true, isRemoved: false, isLoading: false, error: false, errorMessage: null, isAutoApplied: action.data.isAutoApplied });
        }
        case REMOVE_PASSCODE_DONE:
            return Object.assign(Object.assign({}, state), { isUpdated: false, isRemoved: true, isLoading: false, error: false, errorMessage: null, isAutoApplied: action.data.isAutoApplied });
        case SET_PASSCODE_ERROR:
        case REMOVE_PASSCODE_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case SET_PASSCODE_RESET:
        case REMOVE_PASSCODE_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map